import { render } from "./ExtendedStockView.vue?vue&type=template&id=43b9a3bf&scoped=true"
import script from "./ExtendedStockView.vue?vue&type=script&lang=js"
export * from "./ExtendedStockView.vue?vue&type=script&lang=js"

import "./ExtendedStockView.vue?vue&type=style&index=0&id=43b9a3bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b9a3bf"]])

export default __exports__